module.exports = __webpack_public_path__ + "static/media/bg.9b47546a.webp";